import styles from "../ProductStatusBox.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { ProductType } from "../../../types/types";

export type ProductStatusProps = {
  title: string;
  price: string;
  statusMessage: string;
  handleDescriptionCTA: () => void;
  productType?: ProductType;
  showHowToGetIt: boolean;
  hideViewDescriptionLink?: boolean;
  hideTitle?: boolean;
};

export const ProductStatus = ({
  productType,
  statusMessage,
  price,
  title,
  handleDescriptionCTA,
  showHowToGetIt,
  hideViewDescriptionLink = false,
  hideTitle = false,
}: ProductStatusProps) => {
  const StatusMessageComponent = hideTitle ? "h1" : "p";
  const shouldHideDescriptionCTA = hideViewDescriptionLink && !showHowToGetIt;

  return (
    <div className={styles.info}>
      <StatusMessageComponent
        className={hideTitle ? styles.statusMessageSmall : styles.statusMessage}
      >
        {statusMessage}
      </StatusMessageComponent>
      {!hideTitle && <h1 className={styles.title}>{title}</h1>}
      {price && <p className={styles.price}>{price}</p>}

      {productType !== "RetiredStaticBundle" && !shouldHideDescriptionCTA ? (
        <UnderlinedButton
          className={hideTitle ? styles.statusLinkNoMargin : styles.statusLink}
          data-testid="skiplinks:top-box-description"
          onClick={handleDescriptionCTA}
          labelText={
            showHowToGetIt ? "See how to get it" : "View product description"
          }
        />
      ) : (
        <UnderlinedButton
          tag="a"
          className={hideTitle ? styles.statusLinkNoMargin : styles.statusLink}
          data-testid="skiplinks:top-box-howToReturn"
          href="/customer-services/returns/how-do-i-return-an-item"
          labelText="How to return an item"
        />
      )}
    </div>
  );
};
